import { useMutation } from "react-query";
import { createSocialHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useCreateSocialHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createSocialHistory(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the social history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    createSocialHistoryMutation: mutate,
    isCreateSocialHistoryLoading: isLoading,
    ...rest,
  };
};

export default useCreateSocialHistory;
